module.exports = __webpack_public_path__ + "static/media/mintlogo.5f442403.png";